var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityKey = function SvgSecurityKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 4.20592L12.9899 2.15668C12.4499 1.94777 11.5689 1.94777 11.029 2.15668L5.81882 4.20592C4.81468 4.60383 4 5.83735 4 6.96145V15.0191C4 15.8249 4.50207 16.8893 5.11782 17.3668L10.328 21.4554C11.2469 22.1815 12.7531 22.1815 13.6719 21.4554L18.8821 17.3668C19.4978 16.8794 19.9999 15.8249 19.9999 15.0191V6.96145C20.0094 5.83735 19.1947 4.60383 18.2 4.20592ZM12.7152 12.8605V15.4767C12.7152 15.8846 12.3931 16.2228 12.0047 16.2228C11.6163 16.2228 11.2942 15.8846 11.2942 15.4767V12.8605C10.3374 12.5422 9.63644 11.6071 9.63644 10.5029C9.63644 9.13007 10.6974 8.01592 12.0047 8.01592C13.312 8.01592 14.3729 9.13007 14.3729 10.5029C14.3729 11.617 13.6719 12.5422 12.7152 12.8605Z",
    fill: "#037DD6"
  })));
};
export default SvgSecurityKey;